const zindex = {
  navbar: 2,
  // modal-overlay: 3,
  // modal: 4,
  alert: 5
}

export default zindex



// WEBPACK FOOTER //
// ./src/styles/zindex.js